// ---- AUTH CONSTANTS
export const LOGIN_START = 'LOGIN_START';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const CHECK_SESSION = 'CHECK_SESSION';
export const LOGOUT_START = 'LOGOUT_START';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const REGISTER_START = 'REGISTER_START';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';

// ---- ERROR CONSTANTS
export const SET_AUTH_ERR_MSG = 'SET_AUTH_ERR_MSG';
export const CLEAR_AUTH_ERR_MSG = 'CLEAR_AUTH_ERR_MSG';
export const SET_PROFILE_ERR_MSG = 'SET_PROFILE_ERR_MSG';
export const SET_NEWSFEED_ERR_MSG = 'SET_NEWSFEED_ERR_MSG';

// ---- LOADING CONSTANTS
export const SET_AUTH_LOADING = 'SET_AUTH_LOADING';
export const SET_CREATE_POST_LOADING = 'SET_CREATE_POST_LOADING';
export const SET_GET_USER_LOADING = 'SET_GET_USER_LOADING';
export const SET_GET_FEED_LOADING = 'SET_GET_FEED_LOADING';

// ---- FEED CONSTANTS
export const GET_FEED_START = 'GET_FEED_START';
export const GET_FEED_SUCCESS = 'GET_FEED_SUCCESS';
export const CREATE_POST_START = 'CREATE_POST_START';
export const CREATE_POST_SUCCESS = 'CREATE_POST_SUCCESS';
export const UPDATE_FEED_POST = 'UPDATE_FEED_POST';
export const DELETE_FEED_POST = 'DELETE_FEED_POST';
export const UPDATE_USER_POST = 'UPDATE_USER_POST';
export const CLEAR_FEED = 'CLEAR_FEED';
export const HAS_NEW_FEED = 'HAS_NEW_FEED';
export const UPDATE_POST_LIKES = 'UPDATE_POST_LIKES';

// ---- PROFILE CONSTANTS
export const UPDATE_PROFILE_INFO = 'UPDATE_PROFILE_INFO';
export const UPDATE_PROFILE_PICTURE = 'UPDATE_PROFILE_PICTURE';
export const UPDATE_COVER_PHOTO = 'UPDATE_COVER_PHOTO';
export const UPDATE_AUTH_PICTURE = 'UPDATE_AUTH_PICTURE';
export const GET_USER_START = 'GET_USER_START';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';

// ---- CHAT CONSTANTS
export const INITIATE_CHAT = 'INITIATE_CHAT';
export const MINIMIZE_CHAT = 'MINIMIZE_CHAT';
export const CLOSE_CHAT = 'CLOSE_CHAT';
export const CLEAR_CHAT = 'CLEAR_CHAT';
export const GET_MESSAGES_SUCCESS = 'GET_MESSAGES_SUCCESS';
export const NEW_MESSAGE_ARRIVED = 'NEW_MESSAGE_ARRIVED';

// ---- SETTINGS CONSTANTS
export const SET_THEME = 'SET_THEME';

// ---- HELPERS CONSTANTS
export const SET_TARGET_COMMENT = 'SET_TARGET_COMMENT_ID';
export const SET_TARGET_POST = 'SET_TARGET_POST';

// ---- MODAL CONSTANTS
export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';